import { useOverviewContext } from "@features/overview-v2/hooks";

import { TileModal } from "./tile-modal";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const AddTileModal = ({ isOpen, onClose }: Props) => {
  const { addNewTile } = useOverviewContext();

  return (
    <TileModal
      isOpen={isOpen}
      onClose={onClose}
      title="Add tile"
      submitButtonText="ADD TO DASHBOARD"
      onSubmit={(values) => {
        onClose();
        addNewTile(values, {
          successMessage: "Tile successfully addded.",
        });
      }}
    />
  );
};
